<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div class="loading" v-if="processando">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
      </div>

      <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalMapa">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-body">
              <div class="col-md-12">                  
                <div class="row">
                  <gmap-map
                    :center="center"
                    :zoom="12"
                    ref="map"
                    style="width:calc(100vw - 58px);  height: calc(100vh - 158px)"
                  >
                    <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                      <span v-html="infoContent"></span>
                    </gmap-info-window>
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in markers"
                      :position="m.position"
                      @click="toggleInfoWindow(m,index)"
                    ></gmap-marker>
                    <gmap-polyline v-if="path.length > 0" :path="path" :editable="false"
                        ref="polyline">
                    </gmap-polyline>
                  </gmap-map>  
                  
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalMapa = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-title">
          <strong></strong>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <h3>Relatório de Viagem</h3>
            </div>
            <div class="col-md-6 text-right">
              <router-link id="btnNovoVeiculo" class="btn btn-danger" to="/relatorios">
                <span class="glyphicon glyphicon-plus"></span> Fechar
              </router-link>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-3">
                  <strong>Data: </strong>{{dadosRelatorios.data}}
                </div>
                <div class="col-md-3">
                  <strong>Veículo: </strong> {{dadosRelatorios.veiculo}}
                </div>
                <div class="col-md-3">
                  <strong>Empresa: </strong>{{dadosRelatorios.empresa}}
                </div>
                <div class="col-md-3">
                  <strong>Distância Percorrida: </strong>{{formatarVelocidade(dadosRelatorios.distanciaPercorrida)}} Km
                </div>

              </div>
              <br>
            </div>
          </div>

          <template v-if="processando === false">
            <template v-if="dadosRelatorios.dados.length > 0">
              <table class="table table-responsive-sm table-hover table-outline mb-0">
                <thead class="thead-light">
                  <tr>
                    <th width="110">INICIO</th>
                    <th width="110">FINAL</th>
                    <th>DURACAO</th>
                    <th width="120">DISTANCIA</th>

                    <th width="150" class="text-center">Valores Máximos<br>VEL / RPM / TEMP</th>
                    <th width="300" class="text-center">Movimentos Bruscos<br>Acel. / Desacel. / Curva / T. de faixa</th>
                    <th width="50">TEMPO PARADO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(dados, i) in dadosRelatorios.dados" :class="{ 'selecionado': selecionado(dados) }" @click="selecionarItem(dados, $event)" >
                    

                    <td>
                      <input :id="'latitude_'+i" type="hidden" v-model="dados.latitude" />
                      <input :id="'longitude_'+i" type="hidden" v-model="dados.longitude" />
                      <small class="text-muted">{{dados.dataHoraOn}}</small></td>
                    <td><small class="text-muted">{{dados.dataHoraOff}}</small></td>
                    <td><small class="text-muted">{{dados.duracao}}</small></td>
                    <td><small class="text-muted">{{formatarVelocidade(dados.distancia)}} Km</small></td>
                    <td class="text-center"><small class="text-muted">{{formatarVelocidade(dados.velocidadeMaxima)}} Km/h / {{dados.rotacaoMaxima}} / {{dados.temperaturaMaxima}} º</small></td>
                    <td class="text-center"><small class="text-muted">{{dados.bruscaAceleracao}} / {{dados.bruscaDesaceleracao}} / {{dados.curvaAcentuada}} / {{dados.trocaFaixaRapida}}</small></td>
                    <td><small class="text-muted">{{dados.paradoTempo}}</small></td>
                  </tr>
                </tbody>
                
              </table>
            </template>          
            <template v-else>
              <div id="relatorio-sem-dados">
                <h1><bold>Sem dados para o período</bold></h1>
              </div>
            </template>
          </template>
        </div>
      </div> 
    </div>                               
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: {
        data: '',
        veiculo: '',
        empresa: '',
        distanciaPercorrida: '0',
        velocidadeMedia: '0',
        velocidadeMaxima: '0'
      },
      selecionados: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMapa: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    }
  },
  mounted () {
    this.buscarRelatorio()
  },
  methods: {
    selecionarItem: function (item, event) {
      this.selecionada = item.id
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          let p = this.selecionados.indexOf(item)
          this.selecionados.splice(p, 1)
        } else {
          this.selecionados.push(item)
        }
      } else {
        if (this.selecionados.includes(item)) {
          let p = this.selecionados.indexOf(item)
          this.selecionados.splice(p, 1)
        } else {
          this.selecionados = []
          this.selecionados.push(item)
        }
      }
    },
    selecionado: function (item) {
      return this.selecionados.includes(item)
    },
    buscarRelatorio: function () {
      var self = this
      self.processando = true
      var veiculoId = this.$route.params.veiculoId
      var dataHoraInicial = this.$route.params.dataHoraInicial
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/')
      var dataHoraFinal = this.$route.params.dataHoraFinal
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/')
      var filtroVelocidade = this.$route.params.filtroVelocidade
      var desprezarVelocidade = this.$route.params.desprezarVelocidade
      var agruparPosicoes = this.$route.params.agruparPosicoes
      var obdIgnicao = this.$route.params.obdIgnicao
      var obdRpm = this.$route.params.obdRpm
      var obdTemperatura = this.$route.params.obdTemperatura
      var obdErro = this.$route.params.obdErro
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/relatorios/relatorioDePosicoesObdTrip?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes + '&obdIgnicao=' + obdIgnicao + '&obdRpm=' + obdRpm + '&obdTemperatura=' + obdTemperatura + '&obdErro=' + obdErro
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosRelatorios = dadosCadastro
        self.processando = false
      })
    },
    visualizarMapa: function () {
      let self = this
      self.showModalMapa = true
      self.adicionarMarkers()
    },
    adicionarMarkers () {
      let self = this
      self.removerMarkers()
      let bounds = null
      let myLatLng = null
      if (self.selecionados.length > 0) {
        for (let i = 0; i < self.selecionados.length; i++) {
          console.log(self.selecionados[i].latitude)
          if (self.selecionados[i].latitude !== 0) {
            let marker = {}
            if (self.selecionados[i].latitude !== '0') {
              marker = {
                lat: self.selecionados[i].latitude,
                lng: self.selecionados[i].longitude
              }
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.selecionados[i].hora, ignicao: self.selecionados[i].ignicao, velocidade: self.selecionados[i].velocidade, pontoMaisProximo: self.selecionados[i].pontoMaisProximo })
            self.path.push({
              lat: self.selecionados[i].latitude,
              lng: self.selecionados[i].longitude
            })
            // self.markers.push({ position: marker, descricao: self.dadosGrid[i].placaVeiculo, dataHora: self.dadosGrid[i].dataHora, ignicao: self.dadosGrid[i].ignicao, movimento: self.dadosGrid[i].movimento, gprs: self.dadosGrid[i].gprs, velocidade: self.dadosGrid[i].velocidade, pontoMaisProximo: self.dadosGrid[i].pontoMaisProximo })
            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng })
            bounds = new window.google.maps.LatLngBounds()
            bounds.extend(myLatLng)
          }
        }
      } else {
        for (let i = 0; i < self.dadosRelatorios.dados.length; i++) {
          console.log(self.dadosRelatorios.dados[i].latitude)
          if (self.dadosRelatorios.dados[i].latitude !== 0) {
            let marker = {}
            if (self.dadosRelatorios.dados[i].latitude !== '0') {
              marker = {
                lat: self.dadosRelatorios.dados[i].latitude,
                lng: self.dadosRelatorios.dados[i].longitude
              }
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.dadosRelatorios.dados[i].hora, ignicao: self.dadosRelatorios.dados[i].ignicao, velocidade: self.dadosRelatorios.dados[i].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[i].pontoMaisProximo })
            self.path.push({
              lat: self.dadosRelatorios.dados[i].latitude,
              lng: self.dadosRelatorios.dados[i].longitude
            })
            // self.markers.push({ position: marker, descricao: self.dadosGrid[i].placaVeiculo, dataHora: self.dadosGrid[i].dataHora, ignicao: self.dadosGrid[i].ignicao, movimento: self.dadosGrid[i].movimento, gprs: self.dadosGrid[i].gprs, velocidade: self.dadosGrid[i].velocidade, pontoMaisProximo: self.dadosGrid[i].pontoMaisProximo })
            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng })
            bounds = new window.google.maps.LatLngBounds()
            bounds.extend(myLatLng)
          }
        }
      }
      // self.$refs.map.fitBounds(bounds)
      // self.center = marker
      self.currentPlace = null
      // self.$refs.map.fitBounds(self.markers)
      // })
    },
    removerMarkers () {
      let self = this
      self.markers = []
      self.path = []
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + marker.velocidade + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>'
      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/views/relatorios/RelatorioDePosicoesObdTripView.vue